import React, { FC } from 'react';
import NavigationItems from './components/navigationItem';
import { TNavigationBarItemProps } from './types/navigationBarItem.types';

const NavigationBarItem: FC<TNavigationBarItemProps> = ({ item, isLast = false, extraClassName, onClick }) => {
  const isNotClickable = item?.url?.trim().length === 0;

  return (
    <>
      {item.text && (
        <li
          className={`nav-bar__item ${isLast ? ' nav-bar__item--last' : ''} ${
            isNotClickable ? ' nav-bar__item--text' : ''
          } ${extraClassName}`}
        >
          <NavigationItems isNotClickable={isNotClickable} item={item} isLast={isLast} onClick={onClick} />
        </li>
      )}
    </>
  );
};

export default NavigationBarItem;
